import Styles from "./projects.module.css";
import { Headline, Image, Attribute, ProHeadline } from "../../subcomponents/subcomponents";
export const Projects       = ( props ) => {
    const { projects = [], filter } = props;
    const { Projects } = Styles;
    return (
        <main className={ Projects }>
            {
                projects.map(( value, key) => {
                    const { image, imageTheme, members, state, stateTheme, name, nameTheme, link, category } = value;
                    return filter === "All" ? 
                        <Project 
                            image       = { image      }
                            imageTheme  = { imageTheme }
                            members     = { members    }
                            state       = { state      }
                            stateTheme  = { stateTheme }
                            name        = { name       }
                            nameTheme   = { nameTheme  }
                            link        = { link       }
                            key         = { key        }
                        /> : filter === category &&
                        <Project
                            image       = { image      }
                            imageTheme  = { imageTheme }
                            members     = { members    }
                            state       = { state      }
                            stateTheme  = { stateTheme }
                            name        = { name       }
                            nameTheme   = { nameTheme  }
                            link        = { link       }
                            key         = { key        }
                        />;
                })
            }
        </main>
    );
};
export const ProjectsHeader = ( props ) => {
    const { setFilter, headlines = [] } = props;
    const { ProjectsHeader } = Styles;
    const Attributes = [
        { 
            icon    : <i className="bi bi-bookmark-fill"></i>, 
            span    : <span></span>, 
            text    : "All", 
            color   : "white", 
            onClick : (e) => setFilter("All") 
        },
        { 
            icon    : <i className="bi bi-bookmark-dash-fill" style={{ color: "#e91e63" }}></i>, 
            span    : <span style={{ backgroundColor: "#e91e63" }}></span>, 
            text    : "Started", 
            color   : "#e91e63", 
            onClick : (e) => setFilter("started") 
        },
        { 
            icon    : <i className="bi bi-bookmark-plus-fill" style={{ color: "#ffeb3b" }}></i>, 
            span    : <span style={{ backgroundColor: "#ffeb3b" }}></span>, 
            text    : "Staged", 
            color   : "#ffeb3b", 
            onClick : (e) => setFilter("staged") 
        },
        { 
            icon    : <i className="bi bi-bookmark-check-fill" style={{ color: "#009688" }}></i>, 
            span    : <span style={{ backgroundColor: "#009688" }}></span>, 
            text    : "Completed", 
            color   : "#009688", 
            onClick : (e) => setFilter("completed") 
        },
    ];
    return (
        <header className={ ProjectsHeader }>
            <Attribute   Attributes = { Attributes }/>
            <ProHeadline headlines  = { headlines  }/>
        </header>
    );
};
const Project               = ( props ) => {
    const { image, imageTheme, members, state, stateTheme, name, nameTheme, link } = props;
    const { Project } = Styles;
    const Attributes = [
        { 
            icon   : <i className="bi bi-people-fill"></i>, 
            span   : <span></span>, 
            text   : members 
        },
        { 
            icon   : <i className="bi bi-bar-chart-fill" style={{ color: stateTheme }}></i>, 
            span   : <span style={{ backgroundColor: stateTheme }}></span>, 
            text   : state, 
            color  : stateTheme 
        },
        { 
            icon   : <i className="bi bi-folder-symlink-fill" style={{ color: "#4caf50" }}></i>, 
            span   : <span style={{ display: "none" }}></span>,
            link   : link,
        },
    ];    
    return (
        <div className={ Project }>
            <Image 
                src   = { image      }
                theme = { imageTheme }
                link  = { link       }
            />
            <Attribute 
                Attributes = { Attributes }
                width      = { 400        }
            />
            <Headline 
                icon  = { <i className="bi bi-briefcase-fill"></i> } 
                text  = { name                                     }
                width = { 400                                      }
                theme = { nameTheme                                }
                link  = { link                                     }
            />
        </div>
    );
};